import { useEffect, useState } from "react";
import { deleteTheme, getThemesPanel} from "../../services/ThemeServices";
import { ThemeContext } from "./ThemeContext"

export const ThemeState = ({ children }) => {

    const getThemePanelData = async (searchTerm, numPagina, filas) => {
        let res = await getThemesPanel(searchTerm, numPagina, filas)
        console.log("res",res)
        return res;
    }

    const deleteThemeData = async (body,search,numpag,filas) => {
        const res = await deleteTheme(body)
        if (res) getThemePanelData(search,numpag,filas)
        return res
    }

    return <ThemeContext.Provider value={{
        deleteThemeData,
        getThemePanelData,
    }} >
        {children}
    </ThemeContext.Provider>
}